/**
 * 品番の接頭辞から品番グループを解決する（最長一致）。
 *
 * 品番は品番グループから発番されるので、品番があればグループは決まっている。
 * 「システムが分かることは尋ねない」— 資産を登録 と 必要部品を追加 の両方が
 * ここを使う。二重定義すると片方だけ直して食い違うため、定義元はここだけ。
 */
export const groupFromSku = (sku, groups) => {
  // 部署の記号（`ENG/` `IT/`）は番号の一部ではないので外して見る（§8.10）。
  const up = String(sku || '').toUpperCase().replace(/^[A-Z0-9]{1,8}\s*\/\s*/, '');
  if (!up) return '';
  const hit = (groups || [])
    .filter((g) => g.code && up.startsWith(String(g.code).toUpperCase()))
    .sort((a, b) => b.code.length - a.code.length)[0];
  return hit ? hit.code : '';
};
